// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { onePageCheckoutPromotionStyles } from "@west/App/Widgets/OnePageCheckout/OnePageCheckoutPromotion";
import { color } from "@west/XDL/Utilities";
import { css } from "styled-components";

onePageCheckoutPromotionStyles.promoFieldContainer = {
    css: css`
        display: flex;
        gap: 10px;
        width: 100%;
        border: 1px solid ${color("common.ui5")};
        background-color: ${color("common.ui16")};
        box-shadow: inset 0 1px 0 0 ${color("common.black", 0.1)};
        padding: 3px;
        align-items: center;
    `,
};

onePageCheckoutPromotionStyles.promotionTagsContainer = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        row-gap: 8px;
    `,
};

onePageCheckoutPromotionStyles.promotionErrorMessage = {
    size: 12,
    color: "danger",
};

onePageCheckoutPromotionStyles.enterPromotionCodeTextField = {
    sizeVariant: "small",
    cssOverrides: {
        formField: css`
            input:not(.react-datetime-picker__inputGroup__input):not([name="datetime"]):not([class^="PopoverTriggerInput"]) {
                &,
                &:focus:not([disabled]),
                &:hover:not([disabled]) {
                    border: none;
                    box-shadow: none;
                }
            }
        `,
    },
};

onePageCheckoutPromotionStyles.enterPromotionCodeApplyButton = {
    sizeVariant: "small",
    variant: "primary",
};

onePageCheckoutPromotionStyles.promoContainer = {
    css: css`
        display: flex;
        gap: 8px;
        flex-direction: column;
    `,
};
